export const PAY_SELECT_METHOD_REQUEST = "PAY_SELECT_METHOD_REQUEST";
export const PAY_SELECT_METHOD_SUCCESS = "PAY_SELECT_METHOD_SUCCESS";
export const PAY_SELECT_METHOD_FAIL = "PAY_SELECT_METHOD_FAIL";

